<template>
  <div>
    <b>Vantrue_Cloud_Web</b>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/common/Footer.vue